/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Record } from 'immutable'

const AccountTitleState = Record({
  id: null,
  account_title_group_id: null,
  account_title_group_name: '',
  name: '',
  position: null
})

export default AccountTitleState
